import { ECookies } from './types';
import Cookies from 'js-cookie';

export const clearCookies = () => {
  Cookies.remove(ECookies.TOKEN);
  Cookies.remove(ECookies.REFRESH_TOKEN);
  Cookies.remove(ECookies.TOKEN_EXPIRES_IN);
  Cookies.remove(ECookies.TOKEN_TYPE);
};
